import { ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";

import { CapabilitiesActions, capabilitiesActions } from "../actions/capabilitiesActions";
import { CapabilitiesScope } from "../scopes";

export const initialCapabilitiesState: CapabilitiesState = {
  isAaaUser: false,
  isPitchEnabled: false,
};

export type CapabilitiesState = {
  isAaaUser: boolean;
  isPitchEnabled: boolean;
};

export const updateCapabilities = (
  _state: CapabilitiesState,
  action: ReturnType<typeof capabilitiesActions.updateCapabilities.success>
): CapabilitiesState => action.capabilitiesState;

export const capabilitiesReducer = withScope(
  [CapabilitiesScope],
  new ReducerChain<CapabilitiesState>(initialCapabilitiesState)
    .on(CapabilitiesActions.UPDATE_CAPABILITIES_COMPLETED, updateCapabilities)
    .build()
);
